/* eslint-disable react/destructuring-assignment */
/* eslint-disable jam3/no-sanitizer-with-danger */
import React, { ComponentProps } from 'react';
import cn from 'classnames';

import { ComponentTop } from 'features/analyses/Freeform/FreeformAnalysisLayout/DraggableLibraryItemCardComponentTop';

import styles from './MinitableContent.module.scss';

type PropsComponentTop = ComponentProps<typeof ComponentTop>;

interface IProps {
  readonly contents: {
    readonly webTable: string;
    readonly image: string;
  };
  readonly contentTypeInitial: PropsComponentTop['initialValueRadio'];
  readonly onChangeValueRadio?: PropsComponentTop['onChangeValueRadio'];
  readonly itemExcelCellRange?: NonNullable<
    NonNullable<NonNullable<PropsComponentTop['items']>['excel']>['cellRange']
  >;
}

export class MiniTableContent extends React.Component<
  IProps,
  {
    readonly contentRoot: string;
    readonly contentType: IProps['contentTypeInitial'];
  }
> {
  static defaults = {
    classNameComponentTop: `${MiniTableContent.name}-classNameComponentTop`,
  };

  // eslint-disable-next-line react/state-in-constructor
  state = {
    contentRoot:
      this.props.contentTypeInitial === 'image'
        ? this.props.contents.image
        : this.props.contents.webTable,
    contentType: this.props.contentTypeInitial,
  };

  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-empty-function
  handleComponentTopOnChangeValueRadio: PropsComponentTop['onChangeValueRadio'] =
    (input) => {
      const { props } = this;

      props.onChangeValueRadio?.(input);

      this.setState({
        contentRoot:
          input.current === 'image'
            ? props.contents.image
            : props.contents.webTable,
        contentType: input.current,
      });
    };

  render() {
    const { props, state } = this;

    return (
      <div
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
        className={cn('ck-editor-no-override-styles', styles.root)}
      >
        <ComponentTop
          initialValueRadio={state.contentType}
          items={{
            excel: {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              cellRange: props.itemExcelCellRange,
            },
          }}
          onChangeValueRadio={this.handleComponentTopOnChangeValueRadio}
          propsRoot={{
            className: MiniTableContent.defaults.classNameComponentTop,
          }}
        />

        <div
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
          className={cn('ck-editor-no-override-styles', styles.rootContent)}
          dangerouslySetInnerHTML={{
            __html: state.contentRoot,
          }}
        />
      </div>
    );
  }
}
